__turbopack_context__.v({
  "body": "J4edCq_body",
  "intensity": "J4edCq_intensity",
  "intro": "J4edCq_intro",
  "item": "J4edCq_item",
  "items": "J4edCq_items",
  "panel": "J4edCq_panel",
  "section": "J4edCq_section",
  "tabs": "J4edCq_tabs",
});
